import React from 'react';

export interface IActionRefreshContextValues {
  onOpenActionRefreshModal: () => void,
  onOpenPurchaseFateModal: () => void,
}

const DEFAULT_VALUES: IActionRefreshContextValues = {
  onOpenActionRefreshModal: () => {
    console.info('calling default value for onOpenActionRefreshModal');
  },
  onOpenPurchaseFateModal: () => {
    console.info('Calling default value for onOpenPurchaseFateModal');
  },
};

const ActionRefreshContext = React.createContext<IActionRefreshContextValues>(DEFAULT_VALUES);
ActionRefreshContext.displayName = 'ActionRefreshContext';

ActionRefreshContext.displayName = 'ActionRefreshContext';

export default ActionRefreshContext;